var moduleMap = {
	"./store": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(986)]).then(() => (() => ((__webpack_require__(8986)))));
	},
	"./Menu": () => {
		return Promise.all([__webpack_require__.e(744), __webpack_require__.e(124), __webpack_require__.e(912), __webpack_require__.e(571), __webpack_require__.e(408), __webpack_require__.e(338), __webpack_require__.e(12), __webpack_require__.e(689), __webpack_require__.e(858), __webpack_require__.e(325), __webpack_require__.e(828)]).then(() => (() => ((__webpack_require__(3689)))));
	},
	"./Basket": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(44), __webpack_require__.e(326), __webpack_require__.e(643), __webpack_require__.e(228)]).then(() => (() => ((__webpack_require__(9643)))));
	},
	"./MenuPreview": () => {
		return Promise.all([__webpack_require__.e(744), __webpack_require__.e(702), __webpack_require__.e(408), __webpack_require__.e(830), __webpack_require__.e(325), __webpack_require__.e(979), __webpack_require__.e(488)]).then(() => (() => ((__webpack_require__(2865)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});